import React, { useEffect, useState } from 'react'
import {
    Tab, TableRow, TableHeaderCell, TableHeader, TableCell, TableBody, Icon, Label, Table,
    Button, Select,
    Checkbox,
    Modal,
    ModalHeader,
    ModalContent,
    ModalActions,
    Input,
    Form,
    FormField
} from 'semantic-ui-react'
// import { DriverSync } from '../dummyData/DriverSync'
import { RequestPayload } from '../services/ApiClient/types'
import { formatDate, formatTimeRaw } from '../utils/datehelper';
import { routeService } from '../services'
import { useNavigate } from 'react-router-dom'
import DatePicker from "react-datepicker";
import MapDashboard from './MapDashboard';
import { statesArray } from '../utils/statesArray';
import LeafletMap from './LeafletMap';
// const _ = require('lodash');
type Props = {}

const DriverTable = (props: Props) => {
    const [showStops, setShowStops] = useState([])
    const [selectedRoute, setSelectedRoute] = useState(null)
    // const [showStops, setShowStops] = useState(Array(DriverSync.length).fill(false));
    // const [showStops, setShowStops] = useState(true);
    // const [showManageStops, setShowManageStops] = useState(Array(DriverSync.length).fill(false));
    const [date, setDate] = useState(new Date());
    const [, setNoResponse] = useState(true)
    const [loading, setLoading] = useState(false)
    const [routeData, setRouteData] = useState(null)
    const [formValues, setFormValues] = useState({ driver: '', route: '', phoneNumber: '', action: false, });
    const [isNotValid, setNotIsValid] = useState(true)
    const [openModal, setOpenModal] = useState(false)
    const [modalData, setModalData] = useState(null)
    const [stopsData, setStopsData] = useState(null)
    const [activeTab, setActiveTab] = useState(0)
    const [routeUpdated, setRouteUpdated] = useState([])
    const [cities, setCities] = useState([])
    // const [selectedStop, setSelectedStop] = useState(null)
    const [showMap, setShowMap] = useState(null)
    const navigate = useNavigate();

    // let { route_id } = useParams();
    // console.log('route_id: ', route_id);



    useEffect(() => {
        if (localStorage.token === null || localStorage.token === undefined) {
            const navTo = '/'
            navigate(navTo)
        }
        else {
            localStorage.setItem('route', "DriverSync")
            try {
                let payload: RequestPayload<null> = {
                    queryParams: {
                        pDate: formatDate(date),
                        searchBy: '',
                        searchFor: ''
                    },
                    payload: null
                };

                routeService.GetRouteList(payload)
                    .then(response => {
                        if (response.success) {
                            // console.log("routeService.GetRouteList success");
                            if (response.result.length === 0) setNoResponse(true)
                            else {
                                setNoResponse(false)
                                setRouteData(() => response.result);
                                // console.log("GetRouteList response.results: ", response.result);
                            }
                            setLoading(false);
                        }
                        else {
                            setLoading(false);
                        }
                    });
            } catch (err) {
                console.log(err)
                setLoading(false);
            }
        }
    }, [date, navigate])

    const getStopData = async (route_id: any) => {
        try {
            setLoading(true);
            let query = {
                routeId: route_id,
                pDate: formatDate(date.toLocaleDateString())
            };
            // console.log('route_id: ', route_id);
            let payload: RequestPayload<null> = { queryParams: query, payload: null };
            // setCities([])

            await routeService.GetStopList(payload)
                .then(response => {
                    if (response.success) {
                        console.log("Stop Data results: ", response.result);
                        // setModalData(response.result)
                        setStopsData(response.result)
                        setLoading(false);
                        const routeArrays: any = []
                        response.result.routeStops.map((route: any) => {
                            // console.log('backgroundHexColor: ', route.mostSevereExceptionType.backgroundColorHex)
                            routeArrays.push({
                                position: [route.location.lon, route.location.lat],
                                stopHasException: route.hasException,
                                description: route.location.name,
                                addressName: route.address.replace('<br/>', ' '),
                                stopTopException: {
                                    description: route.exceptionCountCodes,
                                    color: (route?.mostSevereExceptionType?.backgroundColorHex === undefined || route?.mostSevereExceptionType?.backgroundColorHex === null) ? '0000FF' : route?.mostSevereExceptionType?.backgroundColorHex
                                    // color: '0000ff'
                                    // color: '#ff'
                                },
                                routeId: response.result.routeId

                            })
                        })
                        // console.log("routeArrays: ", routeArrays)
                        setCities(routeArrays);
                    }
                    else {
                        console.log('error')
                        setLoading(false);
                    }
                })

        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }
    const getStopDetails = (stopId: number) => {
        let payload: RequestPayload<null> = { queryParams: { stopId }, payload: null };
        routeService.GetStopDetails(payload)
            .then(response => {
                if (response.success) {
                    console.log(response.result)
                    setModalData(response.result)
                }
                else {
                    console.log("API call was not successful");
                }
            })
    }




    // const toggleRowVisibility = (index: number) => {
    //     setShowStops(prevState => {
    //         const newState = [...prevState];
    //         newState[index] = !newState[index];
    //         return newState;
    //     });
    // };
    const toggleModal = (e: any, idx: number, Stop: any) => {
        const { innerText } = e.target
        console.log("e: ", e, " idx: ", idx, " stop: ", Stop);
        // getStopData(selectedStop)
        getStopDetails(Stop.stopId)
        // setModalData(Stop)
        setOpenModal(true)
    }

    const toggleRowVisibility = (index: any, route: any) => {
        setLoading(true)
        console.log("Route for toggleRowVisibility: ", route);
        getStopData(route.map)
        if (index === selectedRoute) {
            setSelectedRoute(null)
        } else {
            setSelectedRoute(index)
        }
        // setShowStops(!showStops)
    }
    const toggleManageRowVisibility = (index: number, route: any) => {
        getStopData(route.map)
        setShowStops(prevState => {
            const newState = [...prevState];
            newState[index] = !newState[index];
            return newState;
        });
        setRouteUpdated([])
    };
    const toggleShowMap = (route: any, index: number) => {
        console.log("Map Index: ", index);
        const { map } = route
        console.log('route: ', map)
        getStopData(map)
        if (index === showMap) {
            setShowMap(null)
        } else {
            setShowMap(index)
        }
    }
    const handleUpdateForm = (e: any) => {
        const { name, value, checked } = e.target;
        console.log(name, value, checked);
        let newValue = value

        if (name === 'action') {
            newValue = checked; // Set action to a boolean
        }

        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: newValue,
        }));
        // Check if all fields are filled and valid (excluding non-string fields)
        // const isFormValid = Object.entries(formValues).every(([key, value]) =>
        //     key === 'action' ? typeof value === 'boolean' : value !== '' && typeof value === 'string'
        // );

        // const isFormValid = Object.values(formValues).every(value =>
        //     value !== '' && typeof value === 'string' || (name === 'action' ? true : false)
        // );
        const isFormValid = Object.values(formValues).every(value =>
            value !== '' && typeof value === 'string' || (name === 'action' ? true : false)
        );
        setNotIsValid(isFormValid);
    };
    const updateRoute = (e: any, idx: number) => {
        console.log(e)
        setRouteUpdated(prevState => {
            const newState = [...prevState];
            newState[idx] = !newState[idx];
            return newState;
        })
    }
    // const createDriver = () => {
    //     setOpenCreate(true);
    // }
    const statusOpts: any = [
        { key: 'on-time', value: 'on-time', text: 'on-time' },
        { key: 'late', value: 'late', text: 'late' },
        { key: 'exception', value: 'exception', text: 'exception' }
    ]
    const routeOpts: any = [
        { key: 'completed', value: 'completed', text: 'completed' },
        { key: 'in-progress', value: 'in-progress', text: 'In Progress' },
        { key: 'pending', value: 'pending', text: 'pending' }
    ]
    const deliveryStatusOpts: any = [
        { key: 'Pending', value: 'Pending', text: 'Pending' },
        { key: 'InProgress', value: 'InProgress', text: 'InProgress' },
        { key: 'Delivered', value: 'Delivered', text: 'Delivered' },
    ]
    const driverDummyData: any = [
        {
            Driver: "John Doe",
            Route: "123 Elm St, Springfield, IL",
            PhoneNumber: 5551234,
            Action: true
        },
        {
            Driver: "Jane Smith",
            Route: "456 Oak St, Springfield, IL",
            PhoneNumber: 5555678,
            Action: false
        },
        {
            Driver: "Sam Johnson",
            Route: "789 Pine St, Springfield, IL",
            PhoneNumber: 5552345,
            Action: true
        }
    ];
    const panes = [
        // Today's
        {
            menuItem: { key: 'Today', icon: 'certificate', content: 'Today' }, render: () =>
            (
                <Tab.Pane>
                    {/* <DatePicker selected={date} onChange={(date) => setDate(date)} /> */}
                    <Table color='blue'>
                        <TableHeader>
                            <TableRow textAlign='center'>
                                <TableHeaderCell>Route Name</TableHeaderCell>
                                <TableHeaderCell>Start Time</TableHeaderCell>
                                <TableHeaderCell>End Time</TableHeaderCell>
                                <TableHeaderCell>Stops</TableHeaderCell>
                                <TableHeaderCell>Status</TableHeaderCell>
                                <TableHeaderCell>Actions</TableHeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {/* map through mock data with table drop downs*/}
                            {/* {DriverSync.map((sync: any, index: number) => {
                                // console.log(sync.stops);
                                return (
                                    <>
                                        <TableRow textAlign='center'>
                                            <TableCell><Icon name='chevron right' onClick={() => toggleRowVisibility(index)} />{sync.routeName}</TableCell>
                                            <TableCell><Icon name='users' /></TableCell>
                                            <TableCell>{sync.currentStop}</TableCell>
                                            <TableCell>{sync.lastLocation}</TableCell>
                                            <TableCell>{sync.nextLocation}</TableCell>
                                            <TableCell>{sync.status}</TableCell>
                                            <TableCell><Icon name='comment' /><Icon name='map pin' /></TableCell>
                                        </TableRow>
                                        {showStops[index] &&
                                            (
                                                <>
                                                    <TableRow>
                                                        <TableHeader>
                                                            <TableHeaderCell>Route Stops</TableHeaderCell>
                                                        </TableHeader>
                                                    </TableRow>
                                                    {sync.stops.map((stop: any) => {
                                                        return (
                                                            <TableRow textAlign='center'>
                                                                <TableCell>{stop.name}</TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell><i>Est: {stop.estimatedTime} {stop.actualTime ? `Actual: ${stop.actualTime}` : null}</i></TableCell>
                                                                <TableCell>{stop.status}</TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                                </>
                                            )
                                        }

                                    </>
                                )
                            })} */}
                            {routeData !== null ?
                                routeData.map((route: any, index: any) => {
                                    // console.log('route: ', route, typeof route);
                                    return (
                                        <>
                                            <TableRow textAlign='center'>
                                                {Object.entries(route).map(([key, value]: any) => {
                                                    if (key === 'route_id') {
                                                        return (
                                                            <>
                                                                <TableCell onClick={() => toggleRowVisibility(index, route)}><Icon name='chevron down' /> {value}</TableCell>
                                                            </>
                                                        )
                                                    } else if (key === 'stops') {
                                                        return (
                                                            <>
                                                                <TableCell>{value}</TableCell>
                                                            </>
                                                        )
                                                    } else if (key === 'start_time' || key === 'end_time') {
                                                        return (
                                                            <>
                                                                <TableCell>{formatTimeRaw(value)}</TableCell>
                                                            </>
                                                        )
                                                    } else if (key === 'completed') {
                                                        return (
                                                            <>
                                                                <TableCell><Checkbox label="Completed" checked={value === 1 ? true : false} /></TableCell>
                                                            </>
                                                        )
                                                    }
                                                })}
                                                <TableCell><Icon name='address book outline' onClick={() => setActiveTab(2)} /> <Icon name='map marker alternate' onClick={() => toggleShowMap(route, index)} /></TableCell>
                                            </TableRow>
                                            {showMap === index && (
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell>
                                                        {/* <div id="map" style={{ height: '20rem', width: '60rem' }}> */}
                                                        <div style={{ height: '20rem', width: '60rem' }}>

                                                            {/* <MapDashboard showLines={true} cities={cities} /> */}
                                                            {!loading && <LeafletMap cities={cities} />}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                            {
                                                selectedRoute === index && (
                                                    <>
                                                        <TableRow>
                                                            <TableHeader>
                                                                <TableHeaderCell>Stops</TableHeaderCell>
                                                            </TableHeader>
                                                        </TableRow>
                                                        {stopsData && stopsData.routeStops.map((stop: any, idx: number) => {
                                                            return (
                                                                <TableRow>
                                                                    <TableCell onClick={(e: any) => toggleModal(e, idx, stop)}>{stop.customerName}</TableCell>
                                                                    <TableCell>{stop.address.replace('<br />', '\n')}</TableCell>
                                                                    <TableCell><i>Time Min: </i>{formatTimeRaw(stop.timeMin)}</TableCell>
                                                                    <TableCell><i>Time Pref: </i>{formatTimeRaw(stop.timePref)}</TableCell>
                                                                    <TableCell><i>Time Max: </i>{formatTimeRaw(stop.timeMax)}</TableCell>
                                                                    <TableCell><i>Status: </i>{stop.status}</TableCell>
                                                                </TableRow>
                                                            )
                                                        })}
                                                    </>
                                                )
                                            }
                                        </>
                                    )
                                })
                                :
                                'No Routes Today'
                            }
                        </TableBody>
                    </Table>
                    {modalData !== null && <Modal
                        onClose={() => setOpenModal(false)}
                        onOpen={() => setOpenModal(true)}
                        open={openModal}
                        size='large'
                    >
                        <ModalHeader>{modalData.routeId}</ModalHeader>
                        <ModalContent style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Form>
                                <FormField>
                                    <Input label='Sequence:' value={modalData.stop.sequence} />
                                    <Input label='Time Completed:' value={modalData.stop.timeCompleted} />
                                    <Input label='Elapsed Time:' value={modalData.stop.elapsedTime} />
                                    <Input label='Address:' value={modalData.stop.address.replace('<br />', ' \n')} />
                                </FormField>
                            </Form>
                        </ModalContent>
                        <ModalActions>

                        </ModalActions>
                    </Modal>}
                </Tab.Pane>
            )
        },
        //Manage
        {
            menuItem: { key: 'Manage', icon: 'chart bar outline', content: 'Manage' }, render: () =>
            (
                <Tab.Pane>
                    <DatePicker selected={date} onChange={(date) => setDate(date)} />

                    <Table color='blue'>
                        <TableHeader>
                            <TableRow textAlign='center'>
                                <TableHeaderCell>Route Management</TableHeaderCell>
                                <TableHeaderCell><Button color='blue'>Add Route</Button></TableHeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {/* {DriverSync.map((sync: any, index: number) => {
                                // console.log(sync.stops);
                                return (
                                    <>
                                        <TableRow textAlign='center'>
                                            <TableCell><Icon name='chevron right' onClick={() => toggleManageRowVisibility(index)} />{sync.routeName}</TableCell>
                                            <TableCell><Select value={sync.status} options={statusOpts} /></TableCell>
                                            <TableCell>{`D${index + 1}`}</TableCell>
                                            <TableCell><Button>Expand</Button></TableCell>
                                            <TableCell><Icon name='trash' /></TableCell>
                                        </TableRow>
                                        {showManageStops[index] &&
                                            (
                                                <>
                                                    <TableRow>
                                                        <TableHeader>
                                                            <TableHeaderCell><Button><Icon name='plus' />Add Stop</Button></TableHeaderCell>
                                                        </TableHeader>
                                                    </TableRow>
                                                    {sync.stops.map((stop: any) => {
                                                        return (
                                                            <TableRow textAlign='center'>
                                                                <TableCell>{stop.name}</TableCell>
                                                                <TableCell>{stop.estimatedTime}</TableCell>
                                                                <TableCell><Select value={stop.status} options={routeOpts} /></TableCell>
                                                                <TableCell><Checkbox label='Will Call' /></TableCell>
                                                                <TableCell><Icon name='trash' /></TableCell>

                                                            </TableRow>
                                                        )
                                                    })}
                                                </>
                                            )
                                        }

                                    </>
                                )
                            })} */}
                            {routeData !== null && routeData.map((route: any, idx: number) => {
                                return (
                                    <>
                                        <TableRow>
                                            <TableCell>{route.route_id}</TableCell>
                                            <TableCell>{route.exceptions === "0" ? "0 - No exceptions" : route.exceptions}</TableCell>
                                            {showStops[idx] && (
                                                <>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                </>
                                            )}
                                            <TableCell><i onClick={() => toggleManageRowVisibility(idx, route)} >Expand &nbsp; &nbsp;</i><Icon color='red' name='trash' /></TableCell>
                                        </TableRow>
                                        {showStops[idx] && (
                                            <>
                                                <TableRow>
                                                    <TableHeader>
                                                        <TableHeaderCell><Button><Icon name='plus' />Add Stop</Button></TableHeaderCell>
                                                    </TableHeader>
                                                </TableRow>
                                                {stopsData !== null && stopsData.routeStops.map((stop: any, idx: number) => {
                                                    // console.log("Arrival Time: ", formatTimeRaw(stop.timeArrived));
                                                    return (
                                                        <TableRow>
                                                            <TableCell><Icon name='eye' /><Input placeholder={stop.customerName} /></TableCell>
                                                            {/* <TableCell><DatePicker selected={date} onChange={(date) => setDate(date)} showTimeSelectOnly /></TableCell> */}
                                                            {/* <TableCell><Input type='time' value={`${new Date(stop.timeArrived).getUTCHours()}:${new Date(stop.timeArrived).getUTCMinutes()}`} fluid onChange={(e, data) => console.log(e, data)} /></TableCell> */}
                                                            <TableCell><Select onChange={(e: any, data: any) => console.log("select e:", e, data, idx)} value={stop.status} options={deliveryStatusOpts} /></TableCell>
                                                            {/* <TableCell><Input type='time' value={`${new Date(stop.timeArrived).getHours()}:${new Date(stop.timeArrived).getMinutes()}`} fluid onChange={(e, data) => console.log(e, data)} /></TableCell> */}
                                                            {/* <TableCell><Input type='time' value={new Date(stop.timeArrived).getMinutes() < 10 ? `${new Date(stop.timeArrived).getHours()}:0${new Date(stop.timeArrived).getMinutes()}` : `${new Date(stop.timeArrived).getHours()}:${new Date(stop.timeArrived).getMinutes()}`} fluid onChange={(e, data) => console.log(e, data)} /></TableCell> */}
                                                            <TableCell>
                                                                <Input
                                                                    type='time'
                                                                    value={new Date(stop.timeArrived).getHours() <= 9 ? new Date(stop.timeArrived).getMinutes() < 10 ?
                                                                        `0${new Date(stop.timeArrived).getHours()}:0${new Date(stop.timeArrived).getMinutes()}` :
                                                                        `0${new Date(stop.timeArrived).getHours()}:${new Date(stop.timeArrived).getMinutes()}` :
                                                                        new Date(stop.timeArrived).getMinutes() < 10 ?
                                                                            `${new Date(stop.timeArrived).getHours()}:0${new Date(stop.timeArrived).getMinutes()}` :
                                                                            new Date(stop.timeArrived).getHours() < 10 ?
                                                                                `0${new Date(stop.timeArrived).getHours()}:${new Date(stop.timeArrived).getMinutes()}` :
                                                                                `${new Date(stop.timeArrived).getHours()}:${new Date(stop.timeArrived).getMinutes()}`}
                                                                    fluid
                                                                    onChange={(e, data) => updateRoute(data, idx)} />
                                                            </TableCell>
                                                            <TableCell><Checkbox onChange={(e: any) => updateRoute(e, idx)} label='Will Call' /></TableCell>
                                                            <TableCell><Icon color='red' name='trash' /></TableCell>
                                                            {routeUpdated[idx] && <TableCell>
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <Icon color='green' name='save' />
                                                                    <Label>Save Changes</Label>
                                                                </div>
                                                            </TableCell>}
                                                        </TableRow>
                                                    )
                                                })}
                                            </>
                                        )}
                                    </>
                                )
                            })}
                            <TableRow>
                                <TableCell>

                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Tab.Pane>
            )
        },
        //Drivers
        {
            menuItem: { key: 'Drivers', icon: 'address book', content: 'Drivers' }, render: () =>
            (
                <Tab.Pane>
                    <Form style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', marginLeft: '70rem' }}>
                        <Input name='driver' value={formValues.driver} onChange={(e: any) => handleUpdateForm(e)} placeholder='Name' />
                        <Input name='route' value={formValues.route} onChange={(e: any) => handleUpdateForm(e)} placeholder='Route' />
                        <Input name='phoneNumber' value={formValues.phoneNumber} onChange={(e: any) => handleUpdateForm(e)} placeholder='Phone Number' />
                        <Input type='checkbox' name='action' checked={formValues.action} onChange={(e: any) => handleUpdateForm(e)} label='Action' />
                        <Button disabled={!isNotValid} style={{ marginBottom: '1rem', marginTop: '1rem' }} color='blue'>Add Driver</Button>
                    </Form>
                    <Table color='blue'>
                        <TableHeader>
                            <TableRow textAlign='center'>
                                <TableHeaderCell>Driver</TableHeaderCell>
                                <TableHeaderCell>Route</TableHeaderCell>
                                <TableHeaderCell>Phone Number</TableHeaderCell>
                                <TableHeaderCell>Actions</TableHeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {driverDummyData.map((driverObj: any) => {
                                return (
                                    <TableRow textAlign='center'>
                                        {Object.entries(driverObj).map(([key, value]: any) => {
                                            if (key === 'Action') {
                                                return (
                                                    <TableCell><Checkbox checked={value} /></TableCell>
                                                )
                                            } else {
                                                return (
                                                    <TableCell>{value}</TableCell>
                                                )
                                            }
                                        })}

                                    </TableRow>

                                )
                            })}
                        </TableBody>
                    </Table>
                    {/* <Modal
                        onClose={() => setOpenCreate(false)}
                        onOpen={() => setOpenCreate(true)}
                        open={openCreate}
                        size='large'
                    >
                        <ModalHeader>Add A Driver</ModalHeader>
                        <ModalContent style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Input placeholder='Name...' />
                            <Input placeholder='Route...' />
                            <Input placeholder='Phone Number...' />
                            <Input placeholder='Actions' />
                        </ModalContent>
                        <ModalActions>
                            <Button color='black' onClick={() => setOpenCreate(false)}>
                                Nope
                            </Button>
                            <Button
                                content="Yep, that's me"
                                labelPosition='right'
                                icon='checkmark'
                                onClick={() => setOpenCreate(false)}
                                positive
                            />
                        </ModalActions>
                    </Modal> */}
                </Tab.Pane>
            )
        }
    ]

    return (
        <div style={{ margin: '0px 20px 0px 20px' }}>
            <Tab panes={panes} activeIndex={activeTab} onTabChange={(e: any, data: any) => setActiveTab(data.activeIndex)} />
        </div>
    )
}

export default DriverTable